// Componente Angular para la gestión de vacaciones de los empleados asociados con un usuario.
// Se importa en vacaciones.module.ts

import { Component, OnInit } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from "@angular/router";
import { EmployeesListService } from "../employees-list.service";
import { VacacionesService } from "../../../services/employees/vacaciones.service";
import { Observable } from "rxjs";
import { Vacaciones } from "../../../models/personal/vacaciones.model";
import { EmployeesListModel } from "../employees-list.model";
import { VacacionesFormComponent } from "./vacaciones-form.component";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { EMPLOYEES_ROUTES } from "../const";
import { consts } from "../../../consts";
import { Utils } from "../../../shared/utils";
import { DummyComponent } from "../../../shared/dummy.component";

@Component({
    selector: "app-vacaciones",
    templateUrl: "./vacaciones.component.html",
    styleUrls: ["./vacaciones.component.css"],
    standalone: false
})
export class VacacionesComponent implements OnInit {
    // #region Propiedades del componente
    empleados: EmployeesListModel[] = [];
    displayedColumns: string[] = [
        "employee",
        "cadenaInicio",
        "cadenaFin",
        "motivo",
        "cadenaFechaSolicitud",
        "acciones",
    ];
    displayedColumnsByEmployee: string[] = [
        "cadenaInicio",
        "cadenaFin",
        "motivo",
        "cadenaFechaSolicitud",
        "nombreEstado",
    ];
    row: Vacaciones = null;
    vacacionesAprobadas$: Observable<Vacaciones[]> =
        this.VacacionesService.vacacionesAprobadas$;
    vacacionesSolicitadas$: Observable<Vacaciones[]> =
        this.VacacionesService.vacacionesSolicitadas$;
    vacaciones: Vacaciones = null;
    vacacionesPorEmpleado: Vacaciones[] = null;
    routes: object[] = [];

    formBusqueda: UntypedFormGroup = null;
    // #endregion

    constructor(
        private router: Router,
        public dialog: MatDialog,
        public dummyComponent: DummyComponent,
        public EmployeesListService: EmployeesListService,
        public VacacionesService: VacacionesService,
        protected snackBar: MatSnackBar
    ) {
        this.routes = EMPLOYEES_ROUTES;
    }

    cancelar(): void {
        if (this.formBusqueda != null) {
            this.formBusqueda.reset();
        }

        this.vacacionesPorEmpleado = [];
    }

    create(): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        const dialogRef = this.dialog.open(VacacionesFormComponent, {
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            data: { empleados: this.empleados, vacaciones: null },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.dummyComponent.redirectTo(this.router.url);
        });
    }

    editar(): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        const dialogRef = this.dialog.open(VacacionesFormComponent, {
            width: "90%",
            maxWidth: "900px",
            maxHeight: "90vh",
            data: { vacaciones: this.row, empleados: this.empleados },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.dummyComponent.redirectTo(this.router.url);
        });
    }

    eliminar(): void {
        if (!Utils.IsTierFour()) {
            this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
                duration: 3000,
            });
            return;
        }

        this.VacacionesService.deleteVacaciones(this.row.id).subscribe({
            next: (resultado) => {
                if (resultado) {
                    this.dummyComponent.redirectTo(this.router.url);
                }
            },
        });
    }

    ngOnInit() {
        // Obtención de los empleados ...
        this.EmployeesListService.getList(true).then((data) => {
            this.empleados = data;
            this.inicializarFormulario();

            // ... y carga de las vacaciones
            this.VacacionesService.getVacaciones();
        });
    }

    nombreEmpleado(uid: number): string {
        const empleado = this.empleados.find((e) => e.uid == uid);
        return empleado ? empleado.name : "";
    }

    obtenerVacacionesPorEmpleado(): void {
        if (this.formBusqueda.valid) {
            this.vacacionesPorEmpleado = [];

            this.VacacionesService.getVacacionesPorEmpleado(
                this.formBusqueda.value.employees_Id
            ).subscribe({
                next: (resultado) => {
                    if (resultado) {
                        this.vacacionesPorEmpleado = resultado;
                    }
                },
            });
        }
    }

    setRow(row: Vacaciones): void {
        this.row = row;
    }

    private inicializarFormulario() {
        this.formBusqueda = new UntypedFormGroup({
            employees_Id: new UntypedFormControl(undefined, [Validators.required]),
        });
    }
  public trackByIndex(i: number) { return i; }

}
